import ButtonBase from '@material-ui/core/ButtonBase';
import CreateIcon from '@material-ui/icons/CreateNewFolder';
import withStyles from '@material-ui/styles/withStyles';
import clsx from 'clsx';
import * as _ from 'lodash';
import moment from 'moment';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import Header from 'UI/header';
import { processRequirement } from 'utils/common';
import {
  FOOD_PREFERENCES_DATA, OCCASIONS_DATA, MEAL_PLAN_DATA, TRANSFER_MODE_DATA
} from 'utils/consts';
import BasicTripDetails from './basicTripDetails';
import Customisations from './customisations';
import SelectTemplate from './selectTemplate';
import RoutePlan from './routePlan';

class ConfirmRequirement extends Component {
  constructor(props) {
    super(props);
    const { request: { tags }, requirement, meta } = this.props;
    const initialState = {
      templateItineraryId: null,
      itineraryTemplateSearchValue: '',
      skip: 0,
      limit: 8,
      origin: {
        value: '',
        valid: false,
        items: [],
      },
      places: {
        value: '',
        valid: false,
        items: [],
      },
      tripDate: '',
      tripDates: {
        from: '',
        to: '',
      },
      duration: 0,
      flightsBooked: false,
      flightArrivalDateTime: null,
      flightDepartureDateTime: null,
      isFlexible: false,
      // travellers: {
      //   adults: 0,
      //   children: 0,
      //   infants: 0,
      // },
      roomings: [{
        adults: 2,
        children: 0,
        infants: 0,      
        childrenAges: [], // Array to store individual child ages
      }],
      tripTypes: {
        value: '',
        valid: false,
        items: [],
      },      
      clientPreferences: '', // new field for Client Preferences
      // Customizations fields
      hotelCategory: '3 Stars',
      paceOfTrip: 'Relaxed',      
      foodPreference: {
        value: '',
        valid: true,
        items: [],
      },
      occasions: {
        value: '',
        valid: true,
        items: [],
      },
      mealPlan: {
        value: '',
        valid: true,
        items: [],
      },
      transferMode: {
        value: '',
        valid: true,
        items: [],
      },
      totalBudget: '',
      customBudget: '',
      errorMsg: '',
      activeTab: 'Basic Trip Details',
      tags: (tags || []).filter((x) => x === 'DATES_NOT_FINAL'),
      allPlaces: false,
      visaAddon: false,
      cruiseAddon: false,
      splitStay: true,
      cruiseName: '',
      cruiseNights: '',
      routes: [],
      cities: [], // Cities from route plan API response
      summary: '', // Summary from route plan API response
      ...processRequirement(requirement, meta.tripTypes),
    };
    this.state = {
      ...initialState,
      hasEdits: false,
    };
  
    // Food preferences data for selection
    this.foodPreferencesData = FOOD_PREFERENCES_DATA;

    this.occasionData = OCCASIONS_DATA;
    
    this.mealPlanData = MEAL_PLAN_DATA;
    
    this.transferModeData = TRANSFER_MODE_DATA;
    
    // Cruise names data
    this.cruiseNamesData = [
      'Genting Dream Cruise',
      'Disney Adventure Cruise',
    ];
    
    // Cruise durations
    this.cruiseNightsData = [
      '1 Night',
      '2 Nights',
      '3 Nights',
      '4 Nights',
      '5 Nights',
      '6 Nights',
      '7 Nights',
    ];
  }

  handleChange = ({
    field, value, noEdits = false, resetRoutes = true,
  }) => {
    const { [field]: itm, hasEdits } = this.state;    
    const changes = {};
    if (itm?.constructor.name === 'Object' && field !== 'roomings') {
      changes[field] = {
        ...itm,
        value,
        valid: false,
      };
    } else {
      changes[field] = value;
    }
    if (field === 'flightsBooked' && value) {
      changes.isFlexible = false;
    } else if (field === 'isFlexible' && value) {
      changes.flightsBooked = false;
    }

    changes.hasEdits = hasEdits || !noEdits;
    if (resetRoutes) {
      changes.routes = [];
    }
    this.setState({ ...changes });
  };

  handleRoomingChange = ({ roomIndex, value, resetRoutes = true }) => {
    const { roomings, routes } = this.state;
    const newRoomings = [...roomings];
    const currentRoom = newRoomings[roomIndex];
    const newChildrenCount = value.children;
    const currentChildrenCount = (currentRoom.childrenAges || []).length;
    
    // Update the room with new values
    newRoomings[roomIndex] = { ...currentRoom, ...value };
    
    // Handle children count changes to update childrenAges array
    if (newChildrenCount !== currentChildrenCount) {
      let newChildrenAges = [...(currentRoom.childrenAges || [])];
      
      if (newChildrenCount > currentChildrenCount) {
        // Add default ages for new children (default to age 5)
        for (let i = currentChildrenCount; i < newChildrenCount; i++) {
          newChildrenAges.push('');
        }
      } else {
        // Remove excess children ages
        newChildrenAges = newChildrenAges.slice(0, newChildrenCount);
      }
      
      newRoomings[roomIndex].childrenAges = newChildrenAges;
    }
    
    this.setState({
      roomings: newRoomings,
      hasEdits: true,
      routes: resetRoutes ? [] : routes,
    });
  };

  handleChildAgeChange = ({
    roomIndex, childIndex, age, resetRoutes = true,
  }) => {
    const { roomings, routes } = this.state;
    const newRoomings = [...roomings];
    if (!newRoomings[roomIndex].childrenAges) {
      newRoomings[roomIndex].childrenAges = [];
    }
    // Handle empty string or invalid values - store empty string
    const ageValue = (age === '' || age === null || age === undefined) ? '' : parseInt(age, 10);
    // Only store valid ages (2-12) or empty string
    newRoomings[roomIndex].childrenAges[childIndex] = (ageValue >= 2 && ageValue <= 12) ? ageValue : '';
    this.setState({
      roomings: newRoomings,
      hasEdits: true,
      routes: resetRoutes ? [] : routes,
    });
  };

  handleRemoveRoom = ({ roomIndex, resetRoutes = true }) => {
    const { roomings, routes } = this.state;
    // Prevent removing the last room
    if (roomings.length <= 1) return;

    const newRoomings = roomings.filter((rooming, index) => index !== roomIndex);
    this.setState({
      roomings: newRoomings,
      hasEdits: true,
      routes: resetRoutes ? [] : routes,
    });
  };

  handleFlightArrivalDateTimeChange = ({ date, resetRoutes = true }) => {
    const { routes } = this.state;
    this.setState({
      flightArrivalDateTime: date,
      hasEdits: true,
      routes: resetRoutes ? [] : routes,
    });
  };

  handleFlightDepartureDateTimeChange = ({ date, resetRoutes = true }) => {
    const { routes } = this.state;
    this.setState({
      flightDepartureDateTime: date,
      hasEdits: true,
      routes: resetRoutes ? [] : routes,
    });
  };

  handleDateSelection = ({ date, dateStr, resetRoutes = true }) => {
    const { from, to } = date;
    const { cruiseNights, routes } = this.state;
    let changes = {};
    if (from && to) {
      changes = {
        duration: `${moment(to)
          .diff(moment(from)) / 86400000}`,
      };
      
      // Reset cruise duration if it exceeds the new maximum nights
      if (cruiseNights) {
        const maxNights = moment(to).diff(moment(from), 'days');
        const selectedNights = parseInt(cruiseNights.split(' ')[0], 10);
        if (selectedNights > maxNights) {
          changes.cruiseNights = '';
        }
      }
    }
    this.setState({
      tripDate: dateStr,
      ...changes,
      tripDates: date,
      hasEdits: true,
      routes: resetRoutes ? [] : routes,
    });
  };

  handleItemSelection = ({
    field, accessor, item, resetRoutes = true,
  }) => {
    const { [field]: stateField, routes } = this.state;
    let modField;
    if (stateField.items) {
      const iIndex = stateField.items.findIndex((i) => i[accessor] === item[accessor]);
      if (iIndex === -1) {
        modField = {
          value: '',
          valid: true,
          items: [item, ...stateField.items],
        };
      }
    } else {
      modField = {
        value: item[accessor],
        valid: true,
        item,
      };
    }
    this.setState({
      [field]: modField,
      hasEdits: true,
      routes: resetRoutes ? [] : routes,
    });
  };

  addTentative = () => {
    const { tags } = this.state;
    const index = tags.indexOf('DATES_NOT_FINAL');
    if (index === -1) {
      this.setState({
        tags: [...tags, 'DATES_NOT_FINAL'],
        hasEdits: true,
      });
    } else {
      const modData = [...tags];
      modData.splice(index, 1);
      this.setState({ tags: modData, hasEdits: true });
    }
  };

  toggleAllPlaces = () => {
    const { allPlaces } = this.state;
    this.setState({
      allPlaces: !allPlaces,
      hasEdits: true,
    });
    this.refreshItineraryTemplates();
  };

  handlePageChange = async (value) => {
    await this.setState({
      skip: value,
    });
    this.refreshItineraryTemplates();
  };

  handleSearchChange = ({
    field, searchType, value, itineraryTemplatesExtras, resetRoutes = true,
  }) => {
    const { getSuggestions } = this.props;
    let type;
    let extras = {};
    if (searchType === 'cities') {
      type = 'cities';
      extras = { includeAddressTypes: ['locality'] };
    } else if (searchType === 'places') {
      type = 'destinations';
      extras = {
        includeAddressTypes: ['locality', 'country', 'administrative_area_level_1', 'administrative_area_level_2'],
        includeIndianPlaces: true,
      };
    } else if (searchType === 'itineraryTemplates') {
      type = 'itineraryTemplates';
      extras = itineraryTemplatesExtras;
    }
    getSuggestions(type, value, extras);
    const { [field]: stateField, routes } = this.state;
    this.setState({
      [field]: {
        ...stateField,
        value,
      },
      routes: resetRoutes ? [] : routes,
    });
  };

  handleSearchValueChange = async (value) => {
    await this.setState({
      itineraryTemplateSearchValue: value,
      skip: 0,
    });
    this.refreshItineraryTemplates();
  };

  refreshItineraryTemplates = () => {
    const {
      places,
      allPlaces,
      skip,
      limit,
      tripDates,
    } = this.state;
    const { itineraryTemplateSearchValue } = this.state;
    this.handleSearchChange({
      field: 'itineraryTemplates',
      searchType: 'itineraryTemplates',
      value: itineraryTemplateSearchValue,
      itineraryTemplatesExtras: {
        placeIds: allPlaces ? [] : places?.items?.map((i) => i._id),
        skip,
        limit,
        nights: moment(tripDates.to).diff(moment(tripDates.from), 'days'),
      },
    });
  };

  componentDidUpdate = () => {
    const { isFetchingSuggestions: isFetchingSuggestionsState } = this.state;
    const { isFetchingSuggestions: isFetchingSuggestionsProps } = this.props;
    if (isFetchingSuggestionsState !== isFetchingSuggestionsProps) {
      this.setState({
        isFetchingSuggestions: isFetchingSuggestionsProps,
      });
    }
  };

  removeHandler = ({
    field, accessor, item, resetRoutes = true,
  }) => {
    const { [field]: varField, routes } = this.state;    
    const modField = { ...varField };
    modField.items = modField.items.filter((d) => d[accessor] !== item[accessor]);

    const changes = {
      [field]: modField,
      hasEdits: true,
    };
    if (resetRoutes) {
      changes.routes = [];
    }
    this.setState(changes);
  };

  handleTabChange = (tab) => {
    const { activeTab } = this.state;
    const newState = {};
    if (tab !== activeTab) {
      if (tab === 'Select Template') {
        newState.isFetchingSuggestions = true;
        this.refreshItineraryTemplates();
      }
      newState.activeTab = tab;
      newState.errorMsg = '';
      newState.error = false;
      this.setState(newState);
    }
  };

  validityChecker = (setError, tab = null) => {
    const {
      activeTab,
      origin, places, tripDates,
      roomings, totalBudget, customBudget,
      hotelCategory, paceOfTrip, tripTypes,
      occasions, foodPreference, clientPreferences,
      visaAddon, cruiseAddon, cruiseName, cruiseNights,
      templateItineraryId,
      flightsBooked, flightArrivalDateTime, flightDepartureDateTime,
    } = this.state;
    const { noLandPackage } = this.props;
    let error = false;
    let errorMsg = '';

    // Use provided tab or fall back to activeTab
    const currentTab = tab || activeTab;

    // Validate Basic Trip Details fields
    if (currentTab === 'Basic Trip Details') {
      // Calculate total adults from all rooms
      const totalAdults = roomings.reduce((sum, room) => sum + (room.adults || 0), 0);

      if (origin.items.length === 0) {
        error = true;
        errorMsg = 'Origin cannot be empty';
      } else if (places.items.length === 0) {
        error = true;
        errorMsg = 'Destination cannot be empty';
      } else if (!tripDates.from || !tripDates.to) {
        error = true;
        errorMsg = 'Trip dates not selected';
      } else if (totalAdults === 0) {
        error = true;
        errorMsg = 'No adults selected for the trip';
      }

      // Check if children are present but ages are not entered
      const hasIncompleteChildAges = roomings.some((room) => {
        if (room.children > 0) {
          const childrenAges = room.childrenAges || [];
          return (childrenAges.length !== room.children) || childrenAges.some((age) => age === '' || age === undefined || age === null);
        }
        return false;
      });

      if (hasIncompleteChildAges && !noLandPackage) {
        error = true;
        errorMsg = 'Please enter ages for all children';
      }

      // Validate flight details if flights are booked
      // if (flightsBooked && (!flightArrivalDateTime || !flightDepartureDateTime)) {
      //   console.log('flightArrivalDateTime', flightArrivalDateTime);
      //   console.log('flightDepartureDateTime', flightDepartureDateTime);
      //   error = true;
      //   errorMsg = 'Flight timings required';
      // }
    } else if (currentTab === 'Customisations') {
      if (totalBudget === 'Enter Custom' && !customBudget?.trim()) {
        error = true;
        errorMsg = 'Custom Budget is required';
      } else if (totalBudget !== 'Enter Custom' && !totalBudget?.trim()) {
        error = true;
        errorMsg = 'Budget is required';
      }

      // Cruise validation if cruise addon is selected and Singapore is selected
      const isSingaporeSelected = places?.items?.some(
        (item) => item.name?.toLowerCase() === 'singapore'
      ) || false;
      if (isSingaporeSelected && cruiseAddon && (!cruiseName || !cruiseNights)) {
        error = true;
        errorMsg = 'Cruise name and duration are required when cruise addon is selected';
      }
    } else if (currentTab === 'Select Template') {
      // No specific validation needed for Select Template tab
      // The template selection is handled in the UI (disabled button)
    }

    if (setError) {
      this.setState({ errorMsg });
    }
    return { error, errorMsg };
  };

  handleClick = (event, templateItineraryId) => {
    const { templateItineraryId: selectedTemplateItineraryId } = this.state;
    this.setState({ 
      templateItineraryId: templateItineraryId === selectedTemplateItineraryId ? null : templateItineraryId,
      hasEdits: true,
    });
  };

  submitHandler = ({ ignoreTemplate, isV3, cloneItinerary }) => {
    const { activeTab, hasEdits } = this.state;
    // For submit, validate all relevant fields based on current tab
    let tabsToValidate = [];
    if (activeTab === 'Basic Trip Details') {
      tabsToValidate = ['Basic Trip Details'];
    } else if (activeTab === 'Customisations') {
      tabsToValidate = ['Basic Trip Details', 'Customisations'];
    } else if (activeTab === 'Select Template') {
      tabsToValidate = ['Basic Trip Details'];
    }

    let hasError = false;
    for (const tab of tabsToValidate) {
      const { error } = this.validityChecker(true, tab);
      if (error) {
        hasError = true;
        break;
      }
    }

    if (hasError) {
      return;
    }
    const {
      itinerary, onSubmit, updateItineraryRequirement, cloneAndOpenItinerary,
    } = this.props;
    const {
      origin, places, tripDates: { from, to }, isFlexible,
      roomings, tripTypes, duration, flightsBooked,
      tags, templateItineraryId, clientPreferences,
      flightArrivalDateTime, flightDepartureDateTime,
      hotelCategory, paceOfTrip, foodPreference, occasions, mealPlan, transferMode,
      totalBudget, customBudget,
      visaAddon, cruiseAddon, splitStay, cruiseName, cruiseNights, routes,
    } = this.state;
    
    // Check if Singapore is selected as a destination
    const isSingaporeSelected = places?.items?.some(
      (item) => item.name?.toLowerCase() === 'singapore'
    ) || false;
    
    const params = {
      origin: origin.items.map((o) => o._id),
      places: places.items.map((d) => d._id),
      departureDate: moment(from).toISOString(),
      arrivalDate: moment(to).toISOString(),
      duration,
      travellers: {
        adults: _.sumBy(roomings, (r) => r.adults || 0),
        children: _.sumBy(roomings, (r) => r.children || 0),
        infants: _.sumBy(roomings, (r) => r.infants || 0),
      },
      roomings,
      tripTypes: tripTypes.items.map((t) => t.code),
      flightsBooked,
      flexible: isFlexible,
      tags,      
      clientPreferences: clientPreferences.trim(),
      templateItineraryId: ignoreTemplate ? null : templateItineraryId,
      flightArrivalDateTime: _.isNil(flightArrivalDateTime) ? null : moment(flightArrivalDateTime),
      flightDepartureDateTime: _.isNil(flightDepartureDateTime) ? null : moment(flightDepartureDateTime),
      hotelCategory,
      paceOfTrip,
      foodPreference: foodPreference.items.map((f) => f.code),
      occasions: occasions.items.map((o) => o.code),
      mealPlan: mealPlan.items.map((m) => m.code),
      transferMode: transferMode.items.map((t) => t.code),
      totalBudget: totalBudget === 'Enter Custom' ? customBudget?.trim() : totalBudget?.trim(),
      addOns: _.compact([
        visaAddon ? 'visa' : null,
        isSingaporeSelected && cruiseAddon ? 'cruise' : null,
      ]),
      cruiseName: isSingaporeSelected && cruiseAddon ? cruiseName : null,
      cruiseNights: isSingaporeSelected && cruiseAddon && !_.isNil(cruiseNights) 
        ? Number(cruiseNights.split(' ')[0]) 
        : null,
      splitStay: splitStay || false,
      routes,
    };
    if (_.isEmpty(itinerary)) {
      onSubmit(params, isV3);
    } else if (cloneItinerary) {
      cloneAndOpenItinerary({ itineraryId: itinerary._id, requirement: params });
    } else {
      updateItineraryRequirement(params);
    }
  };

  render() {
    const {
      onDismiss,
      suggestions,
      classes,
      meta,
      isLoading,
      itinerary,
      request,
      updateItineraryRequirement,
      cloneAndOpenItinerary,
      noLandPackage,
      getSuggestions,
    } = this.props;
    const {
      origin, places, tripDates, roomings, tripTypes,
      flightsBooked, errorMsg, tripDate,
      activeTab, templateItineraryId,
      allPlaces, limit,
      isFetchingSuggestions,
      itineraryTemplateSearchValue,
      clientPreferences, // add clientPreferences to destructuring
      flightArrivalDateTime, // add flight arrival date/time
      flightDepartureDateTime, // add flight departure date/time
      // Customizations fields
      hotelCategory,
      paceOfTrip,      
      foodPreference,
      occasions,
      mealPlan,
      transferMode,
      totalBudget,
      customBudget,
      visaAddon,
      cruiseAddon,
      splitStay,
      cruiseName,
      cruiseNights,
      hasEdits,
      routes,
      isFlexible,
      duration,
      tags,
      cities,
      summary,
    } = this.state;
    
    const tripTypesList = meta.tripTypesV2;
    const foodPreferencesList = this.foodPreferencesData || [];
    const occasionList = this.occasionData || [];
    const mealPlanList = this.mealPlanData || [];
    const transferModeList = this.transferModeData || [];
    const enableAI = !noLandPackage
      && !_.isEmpty(places.items)
      && (places.items || []).every((item) => (['singapore', 'malaysia', 'vietnam', 'united arab emirates', 'indonesia', 'maldives'].includes(item.countryName?.toLowerCase())));
    const enableRoutePlan = !noLandPackage
      && !_.isEmpty(places.items)
      && (places.items || []).some((item) => (['malaysia', 'vietnam', 'united arab emirates', 'indonesia'].includes(item.countryName?.toLowerCase())));
    const tabs = enableAI
      ? _.compact(['Basic Trip Details', 'Customisations', enableRoutePlan ? 'Route Plan' : null])
      : _.compact(['Basic Trip Details', noLandPackage ? null : 'Select Template']);
    return (
      <div className={classes.container}>
        <Header
          onDismiss={onDismiss}
          title={itinerary ? 'Edit itinerary' : 'Create itinerary'}
          Icon={CreateIcon}
          iconClass={classes.iconClass}
        />
        <div className={classes.stepContainer}>
          <div className={classes.stepNumberBar}>
            {tabs.map((tab, index) => {
              const isFirst = index === 0;
              const isLast = index === tabs.length - 1;
              const tabWidth = `${100 / tabs.length}%`;
              return (
                <ButtonBase
                  className={clsx(classes.tabButton,
                    activeTab === tab && classes.activeTab)}
                  key={tab}
                  onClick={() => this.handleTabChange(tab)}
                  style={{
                    borderRadius: activeTab === tab
                      ? (isFirst ? '0 20px 20px 0 ' : isLast ? '20px 0 0 20px' : 20)
                      : 0,
                    width: tabWidth,
                  }}
                >
                  {tab}
                </ButtonBase>
              );
            })}
          </div>
          {activeTab === 'Basic Trip Details' ? (
            <BasicTripDetails
              classes={classes}
              origin={origin}
              places={places}
              suggestions={suggestions}
              tripDates={tripDates}
              tripDate={tripDate}
              roomings={roomings}
              flightsBooked={flightsBooked}
              flightArrivalDateTime={flightArrivalDateTime}
              flightDepartureDateTime={flightDepartureDateTime}
              errorMsg={errorMsg}
              isLoading={isLoading}
              enableAI={enableAI}
              noLandPackage={noLandPackage}
              onRemoveHandler={this.removeHandler}
              onSearchChange={this.handleSearchChange}
              onItemSelection={this.handleItemSelection}
              onDateSelection={this.handleDateSelection}
              onRoomingChange={this.handleRoomingChange}
              onChildAgeChange={this.handleChildAgeChange}
              onRemoveRoom={this.handleRemoveRoom}
              onFlightArrivalDateTimeChange={this.handleFlightArrivalDateTimeChange}
              onFlightDepartureDateTimeChange={this.handleFlightDepartureDateTimeChange}
              onChange={this.handleChange}
              onAddRoom={() => {
                this.setState({
                  roomings: [...roomings, {
                    adults: 2,
                    children: 0,
                    infants: 0,
                    childrenAges: [],
                  }],
                  hasEdits: true,
                });
              }}
              onValidityChecker={this.validityChecker}
              onTabChange={this.handleTabChange}
              onSubmitHandler={this.submitHandler}
            />
          ) : null}
          {activeTab === 'Customisations' ? (
            <Customisations
              classes={classes}
              hotelCategory={hotelCategory}
              paceOfTrip={paceOfTrip}
              tripTypes={tripTypes}
              tripTypesList={tripTypesList}
              occasions={occasions}
              occasionList={occasionList}
              foodPreference={foodPreference}
              foodPreferencesList={foodPreferencesList}
              mealPlan={mealPlan}
              mealPlanList={mealPlanList}
              transferMode={transferMode}
              transferModeList={transferModeList}
              clientPreferences={clientPreferences}
              totalBudget={totalBudget}
              customBudget={customBudget}
              visaAddon={visaAddon}
              cruiseAddon={cruiseAddon}
              splitStay={splitStay}
              cruiseName={cruiseName}
              cruiseNights={cruiseNights}
              cruiseNamesData={this.cruiseNamesData}
              cruiseNightsData={this.cruiseNightsData}
              tripDates={tripDates}
              places={places}
              errorMsg={errorMsg}
              isLoading={isLoading}
              itinerary={itinerary}
              hasEdits={hasEdits}
              enableRoutePlan={enableRoutePlan}
              onChange={this.handleChange}
              onRemoveHandler={this.removeHandler}
              onItemSelection={this.handleItemSelection}
              onValidityChecker={this.validityChecker}
              onSubmitHandler={this.submitHandler}
              onTabChange={this.handleTabChange}
            />
          ) : null}
          {activeTab === 'Select Template' ? (
            <SelectTemplate
              classes={classes}
              itineraryTemplateSearchValue={itineraryTemplateSearchValue}
              allPlaces={allPlaces}
              limit={limit}
              isFetchingSuggestions={isFetchingSuggestions}
              suggestions={suggestions}
              templateItineraryId={templateItineraryId}
              errorMsg={errorMsg}
              isLoading={isLoading}
              onSearchValueChange={this.handleSearchValueChange}
              onToggleAllPlaces={this.toggleAllPlaces}
              onHandleClick={this.handleClick}
              onHandlePageChange={this.handlePageChange}
              onSubmitHandler={this.submitHandler}
            />
          ) : null }
          {activeTab === 'Route Plan' ? (
            <RoutePlan
              key={`route-plan-${activeTab}`}
              routes={routes}
              cities={cities}
              requirement={{
                origin,
                places,
                tripDates,
                roomings,
                tripTypes,
                duration,
                flightsBooked,
                isFlexible,
                tags,
                templateItineraryId,
                clientPreferences,
                flightArrivalDateTime,
                flightDepartureDateTime,
                hotelCategory,
                paceOfTrip,
                foodPreference,
                occasions,
                mealPlan,
                transferMode,
                totalBudget,
                customBudget,
                visaAddon,
                cruiseAddon,
                splitStay,
                cruiseName,
                cruiseNights,
              }}
              onUpdate={this.handleChange}
              summary={summary}
              itinerary={itinerary}
              hasEdits={hasEdits}
              isLoading={isLoading}
              onSubmitHandler={this.submitHandler}
            />
          ) : null }
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {
    width: 1300,
    backgroundColor: theme.colors.white,
  },
  spaceBetween: {
    justifyContent: 'space-between',
    paddingLeft: 0,
    paddingRight: 0,
  },
  footerFlexEnd: {
    padding: '0 0 10px 0',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '20%',
  },
  iconClass: {
    color: theme.colors.primary,
  },
  body: {
    padding: '20px 40px',
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flexDirection: 'row', 
    marginBottom: 30,
    alignItems: 'center',
  },
  itemRow: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingRight: 20,
  },
  input: {
    padding: '0px 5px 0px 15px',
    height: '100%',
    width: '100%',
  },
  wrapperRight: {
    flex: 1,
    borderRadius: 4,
    width: '100%',
    maxWidth: '50%',
    marginLeft: 10,
  },
  wrapperLeft: {
    flex: 1,
    borderRadius: 4,
    maxWidth: '50%',
    width: '100%',
    marginRight: 10,
  },
  stepNumberBar: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    borderRight: `1px solid ${theme.colors.underline}`,
    // backgroundColor: theme.colors.border,
  },
  tabButton: {
    flex: 1,
    height: 36,
    padding: '5px 10px',
    fontWeight: 'bold',
    fontSize: 14,
    letterSpacing: 0.5,
    color: theme.colors.primary,
    backgroundColor: theme.colors.transparent,
  },
  stepContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  activeTab: {
    color: theme.colors.primary,
    backgroundColor: theme.colors.primaryLight,
  },
  itineraryTemplateInput: {
    padding: '5px 15px',
    marginTop: '20px',
    boxSizing: 'border-box',
    borderRadius: 4,
    border: `1px solid ${theme.colors.border}`,
  },
  childrenAgesContainer: {
    marginTop: 20,
    width: '100%',
  },
  roomChildrenSection: {
    marginBottom: 15,
  },
  roomChildrenLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.colors.textDark_1,
    marginBottom: 8,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  childrenAgesLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.colors.textDark_1,
    marginBottom: 8,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  ageDropdownsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
  },
  ageDropdownWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: 90,
    marginRight: 10,
  },
  childLabel: {
    fontSize: 12,
    color: theme.colors.textLight,
    marginBottom: 5,
    fontWeight: 'bold',
    width: 100,
  },
  ageDropdown: {
    minWidth: 90,
  },
  ageSelect: {
    fontSize: 14,
    '& .MuiOutlinedInput-input': {
      padding: '8px 12px',
    },
    height: 40,
  },
  dateButton: {
    borderRadius: 15,
    border: `1px solid ${theme.colors.border}`,
  },
  // Customization styles
  customizationSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginRight: 20,
    justifyContent: 'flex-start',
    '&:last-child': {
      marginRight: 0,
    },
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: theme.colors.textLight,
    marginBottom: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  optionButtonsContainer: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
  },
  optionButton: {
    padding: '8px 16px',
    marginRight: 10,
    borderRadius: 20,
    border: `1px solid ${theme.colors.border}`,
    backgroundColor: theme.colors.white,
    minWidth: 80,
    '&:hover': {
      backgroundColor: theme.colors.primaryLight,
    },
  },
  selectedOption: {
    backgroundColor: theme.colors.primaryLight,
    borderColor: theme.colors.primary,
    '& .MuiTypography-root': {
      color: theme.colors.primary,
      fontWeight: 600,
    },
  },
  optionText: {
    fontSize: 14,
    color: theme.colors.textDark_1,
  },
  clientPreferences: {
    width: '100%',
    '& div': {
      height: 'auto !important',
    },
    '& .MuiInputBase-input::placeholder': {
      lineHeight: 1.5,
    },
    marginBottom: 10,
  },
  travellerSelection: {
    width: '200px',
    marginRight: 10,
  },
  themesSelector: {
    maxWidth: '80%',
  },
  mealPlanSelector: {
    maxWidth: '40%',
  },
  cruiseDetailsContainer: {
    marginTop: 20,
    borderRadius: 10,
    padding: 20,
    width: '100%',
    display: 'flex',
    gap: '20px',
    flexDirection: 'row',
    backgroundColor: 'rgba(230, 126, 34, 0.25)',
    border: '1px solid rgba(230, 126, 34, 0.25)',
  },
  cruiseWarningBox: {
    flex: 3,
  },
  cruiseWarningHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,    
  },
  cruiseWarningIcon: {    
    fontSize: 24,
    marginRight: 10,
    color: '#E67E22',
  },
  cruiseWarningTitle: {
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: 0.5,
    color: '#E67E22',
  },
  cruiseWarningText: {
    fontSize: 14,
    color: '#666666',
    lineHeight: 1.6,
    marginBottom: 16,
  },
  cruisePortalInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  cruisePortalInfoText: {
    fontSize: 14,
    color: '#333333',
  },
  cruisePortalLink: {
    color: theme.colors.primary,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.colors.primary,
    },
  },
  cruiseSelectionsColumn: {
    flex: 2,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    justifyContent: 'flex-start',
  },
  cruiseSelectWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  cruiseSelectLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: '#666666',
    marginBottom: 8,
    letterSpacing: 0.5,
  },
  cruiseSelectControl: {
    width: '100%',
  },
  cruiseSelect: {
    backgroundColor: '#FFFFFF',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors.border,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors.primary,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors.primary,
    },
  },
  submitButton: {
    marginTop: 20,
  },
  deleteIcon: {
    color: '#E67E22',
    fontSize: 20,
  },
  checkbox: {
    marginTop: 10,
  },
  addRoomButton: {
    color: theme.colors.primary,
  },
  splitStayLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: theme.colors.textLight,
    marginBottom: 5,
  },
  splitStayCheckbox: {
    display: 'flex',
    alignItems: 'center',
    
    '& p, & button': {
      color: theme.colors.textLight,
    },
  },
});

ConfirmRequirement.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  updateItineraryRequirement: PropTypes.func.isRequired,
  cloneAndOpenItinerary: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  suggestions: PropTypes.object.isRequired,
  getSuggestions: PropTypes.func.isRequired,
  requirement: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isFetchingSuggestions: PropTypes.bool.isRequired,
  request: PropTypes.object,
  itinerary: PropTypes.object,
  noLandPackage: PropTypes.bool,
};

export default withStyles(styles)(ConfirmRequirement);
